module.exports = __webpack_public_path__ + "img/edu.19fb9004.png";